// extracted by mini-css-extract-plugin
export default {"container":"AUvGU","image":"OjW9K"};